import React from 'react';
import { useTranslation } from '../../i18n';

const HowToPlayPage: React.FC = () => {
  const { t } = useTranslation();

  const hostingItems = [
    { label: t('menu.howToPlay.hosting.castToTv.label'), text: t('menu.howToPlay.hosting.castToTv.text') },
    { label: t('menu.howToPlay.hosting.playToo.label'), text: t('menu.howToPlay.hosting.playToo.text') },
    { label: t('menu.howToPlay.hosting.qrJoin.label'), text: t('menu.howToPlay.hosting.qrJoin.text') },
    { label: t('menu.howToPlay.hosting.roomCode.label'), text: t('menu.howToPlay.hosting.roomCode.text') },
    { label: t('menu.howToPlay.hosting.gameControl.label'), text: t('menu.howToPlay.hosting.gameControl.text') },
    { label: t('menu.howToPlay.hosting.multipleGames.label'), text: t('menu.howToPlay.hosting.multipleGames.text') },
  ];

  const playingItems = [
    { label: t('menu.howToPlay.playing.getCode.label'), text: t('menu.howToPlay.playing.getCode.text') },
    { label: t('menu.howToPlay.playing.chooseLook.label'), text: t('menu.howToPlay.playing.chooseLook.text') },
    { label: t('menu.howToPlay.playing.watchHost.label'), text: t('menu.howToPlay.playing.watchHost.text') },
    { label: t('menu.howToPlay.playing.answerOnDevice.label'), text: t('menu.howToPlay.playing.answerOnDevice.text') },
    { label: t('menu.howToPlay.playing.hostPlaying.label'), text: t('menu.howToPlay.playing.hostPlaying.text') },
    { label: t('menu.howToPlay.playing.speedMatters.label'), text: t('menu.howToPlay.playing.speedMatters.text') },
    { label: t('menu.howToPlay.playing.teamUp.label'), text: t('menu.howToPlay.playing.teamUp.text') },
  ];

  return (
    <div style={{ maxWidth: '900px', margin: '0 auto', color: 'var(--text-primary)' }}>
      <h2 style={{
        fontSize: '2rem',
        marginBottom: '2rem',
        textAlign: 'center',
        color: 'var(--color-primary)',
      }}>
        {t('menu.howToPlay.hostingTitle')}
      </h2>

      <div style={{
        backgroundColor: `rgba(var(--color-primary-rgb), 0.15)`,
        backdropFilter: 'blur(10px)',
        borderRadius: '15px',
        padding: '2rem',
        marginBottom: '3rem',
        lineHeight: '1.8',
        border: `2px solid var(--color-primary)`,
      }}>
        <ul style={{
          margin: 0,
          padding: '0 0 0 1.5rem',
          color: 'var(--text-secondary)',
          fontSize: '1.1rem',
        }}>
          {hostingItems.map((item) => (
            <li key={item.label} style={{ marginBottom: '1rem' }}>
              <strong style={{ color: 'var(--color-accent)' }}>{item.label}</strong> {item.text}
            </li>
          ))}
        </ul>
      </div>

      <h2 style={{
        fontSize: '2rem',
        marginBottom: '2rem',
        marginTop: '3rem',
        textAlign: 'center',
        color: 'var(--color-primary)',
      }}>
        {t('menu.howToPlay.playingTitle')}
      </h2>

      <div style={{
        backgroundColor: `rgba(var(--color-primary-rgb), 0.15)`,
        backdropFilter: 'blur(10px)',
        borderRadius: '15px',
        padding: '2rem',
        lineHeight: '1.8',
        border: `2px solid var(--color-primary)`,
      }}>
        <ul style={{
          margin: 0,
          padding: '0 0 0 1.5rem',
          color: 'var(--text-secondary)',
          fontSize: '1.1rem',
        }}>
          {playingItems.map((item) => (
            <li key={item.label} style={{ marginBottom: '1rem' }}>
              <strong style={{ color: 'var(--color-accent)' }}>{item.label}</strong> {item.text}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default HowToPlayPage;
